export type VariantHintMessage =
  | { key: "Required"; values?: Record<string, number> }
  | { key: "Choose at least {minimum}"; values: { minimum: number } }
  | { key: "Choose up to {maximum}"; values: { maximum: number } }
  | {
      key: "Choose at least {minimum} and up to {maximum}";
      values: { minimum: number; maximum: number };
    }
  | null;

export type GetVariantHintMessageArgs = {
  minimum: number | null | undefined;
  maximum: number | null | undefined;
};

export function getVariantHintMessage({
  minimum,
  maximum
}: GetVariantHintMessageArgs): VariantHintMessage {
  const min = typeof minimum === "number" ? minimum : 0;
  const max = typeof maximum === "number" ? maximum : 0;

  if (min && min > 0) {
    if ((!max && min === 1) || (max === 1 && min === 1)) {
      return { key: "Required" };
    } else if (!max && min > 1) {
      return { key: "Choose at least {minimum}", values: { minimum: min } };
    } else if (max && min === 1) {
      return { key: "Choose up to {maximum}", values: { maximum: max } };
    } else if (max && min > 1) {
      return {
        key: "Choose at least {minimum} and up to {maximum}",
        values: { minimum: min, maximum: max }
      };
    }
  } else if (max) {
    return { key: "Choose up to {maximum}", values: { maximum: max } };
  }

  return null;
}
